import { useLocation, Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import products from "../services/products";

const savedProducts =
  JSON.parse(localStorage.getItem("buySellListings")) || [];

const approvedSavedProducts = savedProducts.filter(
  (product) => product.status === "approved"
);

const allProducts = [
  ...products,
  ...approvedSavedProducts,
];

function Products() {
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const category = params.get("category");
  const search = params.get("search");

  let filteredProducts = allProducts;

  // ==========================================
  // ԿԱՏԵԳՈՐԻԱՅՈՎ ՖԻԼՏՐ
  // ==========================================

  if (category) {
    filteredProducts = filteredProducts.filter(
      (product) =>
        product.category &&
        product.category.toLowerCase() ===
          category.toLowerCase()
    );
  }

  // ==========================================
  // ՈՐՈՆՄԱՆ ՖԻԼՏՐ
  // ==========================================

  if (search) {
    const searchText = search.toLowerCase().trim();

    filteredProducts = filteredProducts.filter(
      (product) => {
        const name =
          product.name ||
          product.title ||
          "";

        const description =
          product.description || "";

        const productCategory =
          product.category || "";

        return (
          name.toLowerCase().includes(searchText) ||
          description
            .toLowerCase()
            .includes(searchText) ||
          productCategory
            .toLowerCase()
            .includes(searchText)
        );
      }
    );
  }

  // ==========================================
  // ԷՋԻ ՎԵՐՆԱԳԻՐ
  // ==========================================

  let pageTitle = "Բոլոր ապրանքները";

  if (search) {
    pageTitle = `Որոնում՝ "${search}"`;
  } else if (category) {
    pageTitle = category;
  }

  return (
    <>
      <Header />

      <main className="products-page">
        <div className="container">

          <div className="products-heading">
            <div>
              <h1>{pageTitle}</h1>

              <p>
                {filteredProducts.length} հայտարարություն
              </p>
            </div>

            {(search || category) && (
              <Link
                to="/products"
                className="clear-filter"
              >
                Մաքրել որոնումը
              </Link>
            )}
          </div>

          {filteredProducts.length === 0 ? (
            <div className="no-products">
              <div className="no-products-icon">
                🔍
              </div>

              <h2>
                Ապրանք չի գտնվել
              </h2>

              <p>
                Փորձիր այլ բառով որոնել։
              </p>

              <Link
                to="/products"
                className="view-product"
              >
                Դիտել բոլոր ապրանքները
              </Link>
            </div>
          ) : (
            <div className="products-grid">

              {filteredProducts.map((product) => (
                <div
                  className="product-card"
                  key={product.id}
                >
                  <Link
                    to={`/products/${product.id}`}
                    className="product-card-link"
                  >
                    <img
                      src={product.image}
                      alt={
                        product.name ||
                        product.title
                      }
                      className="product-image"
                    />

                    <div className="product-content">

                      <span className="product-category">
                        {product.category}
                      </span>

                      <h3>
                        {product.name ||
                          product.title}
                      </h3>

                      <p className="product-price">
                        {product.price}
                      </p>

                    </div>
                  </Link>

                  <div className="product-button-wrapper">

                    <Link
                      to={`/products/${product.id}`}
                      className="view-product"
                    >
                      Դիտել ապրանքը
                    </Link>

                  </div>
                </div>
              ))}

            </div>
          )}

        </div>
      </main>

      <Footer />
    </>
  );
}

export default Products;